/**
 * Determines if a pricing plan is the current plan for a user.
 *
 * @param period - The subscription period to check against user's subscription interval
 * @param item - The pricing card item to compare with the user's role
 * @param userData - User profile data containing subscription information
 * @param role - The user's current role
 *
 * @returns True if the plan matches the user's current plan and subscription period, false otherwise
 */

import type { UserProfile, UserProfileRead } from "epsm-api-types/models";
import type { UserRole } from "@/services/user-auth/user-roles";
import type { PricingCardType, SubscriptionPeriod } from "../../types";

export function checkIfCurrentPlan(
	period: SubscriptionPeriod,
	item: Partial<PricingCardType>,
	userData: Partial<UserProfile & UserProfileRead> | null,
	role: UserRole | null,
): boolean {
	if (!role || !item.plan || !userData) {
		return false;
	}

	const isPlanMatch = item.plan.toLowerCase() === role.toLowerCase();

	if (!userData?.subscriptionInterval) {
		return isPlanMatch;
	}

	return userData.subscriptionInterval === period && isPlanMatch;
}
